module.exports = __webpack_public_path__ + "static/hammer_of_thunderbolts-f763f2ab45cfb4bf304d799442953ae3.jpeg";